import React, { ChangeEvent } from 'react';
import UserService from '../../services/user-service';
import Content from '../dashboard/Content';
import isValid from '../../utils/is-valid';
import { digits } from '../../utils/sanitaize';
import { Redirect } from 'react-router-dom';
import errorDialog from '../../utils/error-dialog';
import { getCurrentUser } from '../../utils/auth';

import './ManageUsers.scss';

interface Props {
  match: {
    params: { userId: string }
  }
}

export default class EditUser extends React.Component<Props> {

  private userService = new UserService();

  state = {
    user: null,
    name: 'در حال بارگذاری',
    username: 'در حال بارگذاری',
    email: 'در حال بارگذاری',
    phoneNumber: 'در حال بارگذاری',
    access: '',
    calendarType: '',
    submitting: false,
    redirect: false,
    errors: {
      name: '',
      username: '',
      email: '',
      phoneNumber: '',
      access: '',
      calendarType: '',
    }
  }

  render() {
    const errors = this.state.errors;
    const errorClass = (value: string) => value ? ' input-error' : '';
    if (this.state.redirect) {
      return <Redirect to="/dashboard/users" />
    }

    return (
      <Content title="خانه / ویرایش کاربر">
        <div className="component-create-user">
          <div className="row">
            <div className="col-md-6 col-12">
              <div className="form-group">
                <label>نام کاربری</label>
                <input
                  type="text"
                  className={"input-app input-lg" + errorClass(errors.username)}
                  value={this.state.username}
                  onBlur={this.validateUsername}
                  onChange={this.handleUsernameChange} />
                <span className="input-error-message">{errors.username}</span>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="form-group">
                <label>آدرس ایمیل</label>
                <input
                  type="text"
                  className={"input-app input-lg" + errorClass(errors.email)}
                  value={this.state.email}
                  onBlur={this.validateEmail}
                  onChange={this.handleEmailChange} />
                <span className="input-error-message">{errors.email}</span>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="form-group">
                <label>شماره موبایل</label>
                <input
                  type="text"
                  value={this.state.phoneNumber}
                  className={"input-app input-lg" + errorClass(errors.phoneNumber)}
                  onBlur={this.validatePhoneNumber}
                  onChange={this.handlePhoneNumberChange} />
                <span className="input-error-message">{errors.phoneNumber}</span>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="form-group">
                <label>نام نمایشی</label>
                <input
                  type="text"
                  value={this.state.name}
                  className={"input-app input-lg" + errorClass(errors.name)}
                  onChange={this.handleNameChange}
                  onBlur={this.validateName}
                />
                <span className="input-error-message">{errors.name}</span>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="form-group">
                <label>نوع کاربر</label>
                <select
                  defaultValue={this.state.access}
                  onChange={this.handleAccessChange}
                  className={"input-app input-lg" + errorClass(errors.access)}
                  onBlur={(e) => e.target.value === '' ? this.setError('calendarType') : ''}>
                  <option value="-1" disabled>انتخاب دسترسی</option>
                  {this.getUserTypes().map((item) => (
                    <option key={item.value} value={item.value}>{item.text}</option>
                  ))}
                </select>
                <span className="input-error-message">{errors.access}</span>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="form-group">
                <label>نوع نمایش تاریخ</label>
                <select
                  defaultValue={this.state.calendarType}
                  className={"input-app input-lg" + errorClass(errors.calendarType)}
                  onChange={this.handleCalendarTypeChange}>
                  <option value="0">شمسی</option>
                  <option value="1">میلادی</option>
                </select>
                <span className="input-error-message">{errors.calendarType}</span>
              </div>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-md-6 col-11 mx-auto">
                  <button
                    onClick={this.handleSubmit}
                    className="btn btn-app btn-block flex-center">
                    <i className={"far fa-spinner fa-spin ml-2 " + (this.state.submitting ? '' : 'd-none')}></i>
                    <span>بروزرسانی اطلاعات</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Content>
    );
  }

  componentDidMount = async () => {
    const currentUser = getCurrentUser();
    const userId = this.props.match.params.userId;
    this.setState({ user: currentUser }, async () => {
      const user = await this.userService.findById(userId);
      this.setState({
        ...this.state,
        ...user
      });
    });
  }

  handleUsernameChange = (event: any) => this.handleUpdateInputText(event, 'username');

  handleEmailChange = (event: any) => this.handleUpdateInputText(event, 'email');

  handleNameChange = (event: any) => this.handleUpdateInputText(event, 'name');

  handlePhoneNumberChange = (event: any) => this.handleUpdateInputText(event, 'phoneNumber', { numeric: true });

  handleAccessChange = (event: any) => { this.handleUpdateInputText(event, 'access') }

  handleCalendarTypeChange = (event: any) => { this.handleUpdateInputText(event, 'calendarType') }

  handleUpdateInputText = (event: ChangeEvent<HTMLInputElement>, context: string, options: any = {}) => {
    let value = digits(event.target.value);
    const errors = { ...this.state.errors };
    let updateErrors = false;

    if (options.numeric && value !== '' && /^[0-9\b]+$/.test(value) === false) {
      return event.preventDefault();
    }
    if (context === 'access') {
      errors.access = '';
      updateErrors = true;
    }
    if (context === 'calendarType') {
      errors.calendarType = '';
      updateErrors = true;
    }

    if (options.noSpace) {
      value = value.trim();
    }
    if (updateErrors) {
      this.setState({ [context]: value, errors });
    }
    else {
      this.setState({ [context]: value });
    }
  }

  validateUsername = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.trim();
    if (!value) return this.setError('username');
    if (value.length < 4) {
      return this.setError('username', 'نام کاربری حداقل باید ۴ کاراکتر باشد');
    }
    if (!isValid.username(value)) {
      return this.setError('username', 'کاراکترهای مجاز حروف انگلیسی، اعداد و - _ هستند.');
    }
    this.setError('username');
  }

  validateName = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value = event.target.value.trim();
    if (value === '') this.setError('name');
  }

  validateEmail = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.trim();
    if (!value) return this.setError('email');
    if (!isValid.email(value)) {
      return this.setError('email', 'ایمیل وارد شده نامعتبر است');
    }
    return this.setError('email');
  }

  validatePhoneNumber = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.trim();
    if (!value) return this.setError('phoneNumber');
    if (!isValid.phoneNumber(value)) {
      return this.setError('phoneNumber', 'شماره موبایل وارد شده نامعتبر است');
    }
    return this.setError('phoneNumber');
  }

  handleSubmit = async () => {
    const state = this.state;
    const userId = this.props.match.params.userId;
    if (!state.email.trim()) {
      await this.setError('username', 'ایمیل نمیتواند خالی باشد');
    }
    if (!state.username.trim()) {
      await this.setError('username', 'نام کاربری نمیتواند خالی باشد');
    }
    if (!state.name.trim()) {
      await this.setError('name', 'نام نمیتواند خالی باشد');
    }
    if (!state.phoneNumber.trim()) {
      await this.setError('phoneNumber', 'شماره موبایل نمیتواند خالی باشد');
    }
    if (!state.access) {
      await this.setError('access', 'سطح دسترسی را انتخاب کنید');
    }
    if (this.hasError()) return;
    this.setState({ submitting: true });
    const allowed = [
      'name', 'username', 'email',
      'phoneNumber', 'access', 'calendarType'
    ];
    const filtered = Object.keys(this.state)
      .filter(key => allowed.includes(key))
      .reduce((obj, key) => {
        obj[key] = this.state[key];
        return obj;
      }, {});
    try {
      await this.userService.update(userId, filtered);
    }
    catch (e) {
      errorDialog(e);
    }
    this.setState({ redirect: true });
  }

  getUserTypes = () => {
    const user = this.state.user;
    if (!user) return [];
    if (user.access === 'admin') {
      return [
        { value: 'admin', text: 'مدیر سیستم' },
        { value: 'company', text: 'اعضای شرکت' },
        { value: 'crm', text: 'CRM' },
        { value: 'customer', text: 'مشتری' },
      ];
    }
    return [
      { value: 'sub-customer', text: 'زیر مجموعه' }
    ];
  }

  hasError = () => {
    const values = Object.values(this.state.errors);
    return values.filter(v => v !== '').length > 0;
  }

  setError = async (context: any, value: string = '') => {
    return new Promise((resolvePromise) => {
      const errors = {
        ...this.state.errors,
        ...{ [context]: value }
      };
      this.setState({ errors }, () => {
        resolvePromise(undefined);
      });
    });
  }

}
